import * as debugTheme from './debug'
import * as defaultTheme from './default'
import * as lightTheme from './light'
import * as blackTheme from './black'
import * as whiteTheme from './white'

const themes = {
  debug: debugTheme,
  dark: defaultTheme,
  light: lightTheme,
  black: blackTheme,
  white: whiteTheme,
}

export default themes
